import React, { useEffect, useState } from "react";
import classNames from "classnames"; // Correct the import here
import AuthUtil from "../../utils/auth";
import LayoutHeader from "../layout-header/layout-header";
import styles from "./layout.module.css";
import LayoutFooter from "../layout-footer/layout-footer";
import SiderBarComponent from "../../components/menu";
import useFetch from "../../hooks/useFetch";
import useToast from "../../hooks/useToast";
import {
  ApiSigninWithToken,
  GetMenuHierarchyList,
} from "../../utils/api.constant";
import { eResultCode } from "../../utils/enum";
import { TResponseModel } from "../../types/config";
import { ToastOpen, ToastType } from "../../state/toast/slice";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import Utils from "../../utils";
import { Typography } from "antd";
const { Text } = Typography;

interface DashboardComponentProps {
  children: React.ReactNode; // Define the type for children
}

export default function DashboardComponent({
  children,
}: DashboardComponentProps) {
  const [isSidebarToggle, setSidebarToggle] = useState(false);
  const onToggleSideBar = () => {
    setSidebarToggle(!isSidebarToggle);
  };
  const [isAdvancePanel, setAdvancePanel] = useState(false);
  const onToggleAdvancePanel = () => {
    setAdvancePanel(!isAdvancePanel);
  };
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isVerifyingToken, setIsVerifyingToken] = useState(true); // Start with true to check token first
  const { post } = useFetch();
  const { showToast, onShowToast } = useToast();

  const autoLoginWithToken = async (rawToken: string) => {
    try {
      const payload = {
        data: {
          authToken: rawToken,
        },
      };

      const response: TResponseModel = await post(ApiSigninWithToken, payload);
      const { dataResponse, data } = response;
      const { returnCode, description } = dataResponse;

      if (returnCode === eResultCode.SUCCESS) {
        AuthUtil.setToken(rawToken as string);
        // onShowToast({
        //   type: ToastType.success,
        //   title: <CheckOutlined />,
        //   position: ToastOpen.centerTop,
        //   content: "Logged in successfully!",
        // });

        setIsAuthenticated(true);
        setIsVerifyingToken(false);
      } else {
        setIsVerifyingToken(false);
        setIsAuthenticated(false);
        onShowToast({
          type: ToastType.error,
          title: <CloseOutlined />,
          position: ToastOpen.centerTop,
          content: description || "Token verification failed",
        });
        window.location.href = "/login";
      }
    } catch (err) {
      console.log("Auto login failed", err);
      setIsVerifyingToken(false);
      setIsAuthenticated(false);
      onShowToast({
        type: ToastType.error,
        title: <CloseOutlined />,
        position: ToastOpen.centerTop,
        content: "Token verification failed. Please log in.",
      });
      window.location.href = "/login";
    }
  };

  // Check for token in URL or existing auth token
  useEffect(() => {
    const checkAuthentication = async () => {
      // First, check if there's a token in the URL (redirected user)
      const params = new URLSearchParams(window.location.search);
      const urlToken = params.get("token");

      if (urlToken) {
        // User was redirected with a token, verify it
        await autoLoginWithToken(urlToken);
        // Clean up URL by removing token parameter
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
        window.location.reload();
      } else if (!AuthUtil.isTokenExist()) {
        // No URL token and no existing token, redirect to login
        setIsVerifyingToken(false);
        setIsAuthenticated(false);
        window.location.href = "/login";
      } else {
        // Existing token found, user is authenticated
        setIsAuthenticated(true);
        setIsVerifyingToken(false);
      }
    };
    checkAuthentication();
  }, []);

  // Show verification state when token is being verified
  if (isVerifyingToken) {
    return (
      <div className={styles.dashboardLayout}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: "20px",
            padding: "40px 20px",
          }}
        >
          <div>
            <img
              src='/webpm-loader.gif'
              alt='loader'
              style={{ width: "80px", height: "80px" }}
            />
          </div>
          <Text
            style={{ fontSize: "18px", fontWeight: 500, color: "#383838ff" }}
          >
            Verifying authentication...
          </Text>
          <Text
            type='secondary'
            style={{ color: "rgba(27, 27, 27, 0.7)" }}
          >
            Please wait while we verify your credentials.
          </Text>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className={classNames(styles.dashboardLayout, "dashboard_layout")}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          className={classNames(
            styles.sidebar,
            { [styles.sidebarExpanded]: isSidebarToggle },
            { [styles.sidebarCollapsed]: !isSidebarToggle },
          )}
        >
          <SiderBarComponent
            sideBarStatus={isSidebarToggle}
            onToggleSideBar={onToggleSideBar}
          />
        </div>
        <div
          className={classNames(
            styles.content,
            { [styles.contentExpanded]: isSidebarToggle },
            { [styles.contentCollapsed]: !isSidebarToggle },
            { [styles.contentAdvanceExpanded]: isAdvancePanel },
            { [styles.contentAdvanceCollapsed]: !isAdvancePanel }
          )}
        >
          {/* Header removed for cleaner layout */}
          {/* <LayoutHeader
            onToggleSideBar={onToggleSideBar}
            sideBarStatus={isSidebarToggle}
          /> */}
          {children}
          <LayoutFooter />
        </div>
        {/* <div
          className={classNames(
            styles.advanceSidebar,
            { [styles.advanceSidebarExpanded]: isAdvancePanel },
            { [styles.advanceSidebarCollapsed]: !isAdvancePanel }
          )}
        ></div> */}
      </div>
    </div>
  );
}
